import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchDeliverable, fetchDeliverableDraft, fetchDeliverableThumbnail } from "./api"

export function useDeliverableThumbnail(id: string, updatedAt: string, enabled: boolean) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["deliverable", id, "thumbnail", updatedAt],
    queryFn: async () => fetchDeliverableThumbnail(await getContext(), id),
    select: (blob: Blob) => blob,
    enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  })
}

export function useDeliverable(id: string) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["deliverable", id],
    refetchInterval: (query) => (query.state.data?.status === "building" ? 2000 : false),
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDeliverable(context, id)
    },
  })
}

export function useDeliverableDraft(id: string) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["deliverableDraft", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDeliverableDraft(context, id)
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  })
}
